import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectTag = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.tag;

export const tag = setCalculationModeProjectTag(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PROJECT_TAG',
  'estimating'
);
